// Cart-specific constants
export const maxSameItem = Number.MAX_VALUE;

// Type declarations for window properties
declare global {
  interface Window {
    volumeLimit: number;
    coldVolumeLimit: number;
  }
}

export const getVolumeLimit = () => window.volumeLimit;
export const getColdVolumeLimit = () => window.coldVolumeLimit;
